module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loaded),
      expression: "loaded"
    }]
  }, [(_vm.detailData) ? _c('div', {
    staticClass: "detail-main"
  }, [_c('div', {
    staticClass: "detail-main-container"
  }, [_c('div', {
    staticClass: "detail-main-back",
    on: {
      "click": _vm._back
    }
  }, [_vm._v(_vm._s(_vm.back))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-main-article"
  }, [_c('div', {
    staticClass: "detail-main-article-conatiner"
  }, [_c('div', {
    staticClass: "dmac-title"
  }, [_vm._v(_vm._s(_vm.detailData['data']['title']))]), _vm._v(" "), _c('div', {
    staticClass: "dmac-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.detailData['data']['publishTime']))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailData['data']['author']))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailData['data']['company']))])]), _vm._v(" "), _c('div', {
    staticClass: "dmac-html"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detailData['data']['content'])
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dmac-addon"
  }, [_c('div', {
    staticClass: "dmac-addon-readmore",
    on: {
      "click": _vm._back
    }
  }, [_vm._v(_vm._s(_vm.readmore))]), _vm._v(" "), (_vm.detailData['relation'].length > 0) ? _c('div', {
    staticClass: "dmac-addon-links"
  }, _vm._l((_vm.detailData['relation']), function(item, index) {
    return _c('div', {
      staticClass: "links-item",
      on: {
        "click": function($event) {
          return _vm._link(item['id'])
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item['title']) + "\n                        ")])
  }), 0) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('j-alert', {
    attrs: {
      "title": "",
      "content": _vm.alertContent,
      "show": _vm.isShowAlert,
      "onHide": _vm.hideAlert
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bd20468"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail.vue
// module id = 291
// module chunks = 1